import type { useDesktopLandingData } from '../use-desktop-landing-data';
import { PopularInterests } from './popular-interests';

export function PopularInterestsDiscoverySection({ data }: { data: ReturnType<typeof useDesktopLandingData> }) {
  const { actions, popularInterestsQuery, showPopularInterests } = data;
  if (data.showLandingCategories) return null;
  return showPopularInterests ? (
    <PopularInterests onTagPress={actions.openOfferTag} tags={popularInterestsQuery.data} />
  ) : null;
}
